<div class="question-type__video">
  <video #targetVideo preload="auto" autoplay mute loop></video>
</div>
